import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { EditRespondentDetailsRPC } from "./editRespondentDetailsRPC";

export class EditRespondentDetailsRPCClientImpl extends EditRespondentDetailsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: EditRespondentDetailsRPC.Request): Promise<LeoRPCResult<EditRespondentDetailsRPC.Response, EditRespondentDetailsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "respondent/EditRespondentDetails",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      EditRespondentDetailsRPC.ResponseDTO,
      EditRespondentDetailsRPC.Errors.ErrorsDTO,
      EditRespondentDetailsRPC.Response,
      EditRespondentDetailsRPC.Errors.Errors
    >(
      response,
      "respondent/EditRespondentDetails",
      EditRespondentDetailsRPC.Response.fromDTO,
      EditRespondentDetailsRPC.Errors.fromDTO
    );
  }
}
